export function authHeaders(authTokens) {
    return authTokens?.access
        ? { Authorization: `Bearer ${authTokens.access}` }
        : {};
}
